import { ExtFormType } from '../../../../api/extForms';
import { Form, FormAttachment, TemplateType } from '../../../../types';

export type MockExtFormProps = Partial<{
  form: Form;
  template: TemplateType;
  attachments: FormAttachment[];
}>;

export const mockExtForm = ({
  form,
  template,
  attachments,
}: MockExtFormProps): ExtFormType | undefined => {
  if (!form || !template || !attachments) return undefined;

  return {
    template: {
      name: form.template.name,
      contractTemplate: template?.contractTemplate,
    },
    signType: 'ANY',
    slug: form.slug,
    attachments: attachments?.map(attachment => ({
      uuid: 'fake-uuid',
      name: attachment.name,
      description: attachment.description,
      maxSize: 5120,
      types: ['pdf', 'jpg', 'jpeg', 'png'],
      required: attachment.required,
    })) as any,
    organisation: {
      name: 'Example',
    },
  };
};
